import React from "react";
import MinimalFooter from "./minimal-footer";

interface IFooterProps {
    isVisible?: boolean;
}

const Footer: React.FC<IFooterProps> = ({ isVisible = true }) => {
    return isVisible ? <MinimalFooter /> : null;
};

export default Footer;
